enum Mutations {
  SET_EMPLOYMENTS = 'setEmployments',
  UPDATE_EMPLOYMENTS = 'updateEmployments',
}

export default Mutations;
